import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2,
  FormFieldV2,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import type { SearchFieldState, SearchFieldActions } from '../../hooks';
import { KhachHang, NhanVien } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  state: SearchFieldState;
  action: SearchFieldActions;
}

const BasicInfoTab = ({ state, action }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeFieldV2 label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      {/* Loại hóa đơn */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Loại chứng từ</Label>
        <FormFieldV2
          name='ma_ngv'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: '', label: 'Tất cả' },
            { value: '5', label: 'Đơn hàng' },
            { value: '4', label: 'Hợp đồng' }
          ]}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Giao dịch</Label>
        <FormFieldV2
          name='ma_gd'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: '', label: 'Tất cả' },
            { value: 'DH', label: 'DH. Đơn hàng' },
            { value: 'HD', label: 'HD. Hợp đồng' }
          ]}
        />
      </div>

      {/* Mã khách hàng */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          onRowSelection={action.setKhachHang}
          value={state.khachHang?.customer_code}
          relatedFieldValue={state.khachHang?.customer_name}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          className='w-100'
        />
      </div>

      {/* Mã nhân viên */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã nhân viên</Label>
        <SearchField<NhanVien>
          type='text'
          name='ma_nvbh'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={nhanVienSearchColumns}
          onRowSelection={action.setNhanVien}
          value={state.nhanVien?.ma_nhan_vien}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien}
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          dialogTitle='Danh mục nhân viên bán hàng'
          className='w-100'
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormFieldV2 name='dien_giai' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
